import { useCallback, useEffect, useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { theme } from '@utils/libs/theme';

export function useMobileOverlay() {
  const [isOpen, setIsOpen] = useState(false);
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const open = useCallback(() => {
    if (isMobile) setIsOpen(true);
  }, [isMobile]);

  const close = useCallback(() => setIsOpen(false), []);

  useEffect(() => {
    if (!isMobile) setIsOpen(false);
  }, [isMobile]);

  return { isOpen, open, close };
}
